import React from 'react'
import Community from './Community';
import Value from './Value';
import BusinessAdvisor from './BusinessAdvisor';
import LeadershipGroup from './LeadershipGroup';
import MissionVision from './MissionVision';
import OurDifferent from './OurDifferent';
import Do from './WhatWeDo';
import OurCounselors from './OurCounselors';
import FaqFooter from '../Home/FAQ/FaqFooter';


export default function AboutUs() {
    return (
        <div className='bg-slate-50 py-4'>
            <Community />
            <Value />
            <Do />
            <OurDifferent />
            <MissionVision />
            <OurCounselors />
            <LeadershipGroup />
            <BusinessAdvisor />
            <FaqFooter />
            
            
        </div>
    );
}